module.exports = __webpack_public_path__ + "img/solidconv.d790c3d2.png";